import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TermlyService {
  private get termly(): any {
    return (window as any).Termly;
  }

  showPreferencesModal() {
    if (this.termly && this.termly.showPreferencesModal) {
      this.termly.showPreferencesModal();
    }
  }
} 